import {useMemo} from 'react'
import {useStorage} from '../../utils/storage'
import {USER_ROLES} from '../../constants/roles'

export const useRole = () => {
  const role = useStorage.getRole()
  const isNotInvestor = useMemo(() => {
    return role !== USER_ROLES.INVESTOR
  }, [role])
  return {role, isNotInvestor}
}
